import React, { Component } from 'react';
import {actions, connect} from 'mirrorx';

import { Scrollbars } from 'react-custom-scrollbars';

import 'react-reflex/styles.css';
import './layout.css';

import {
  ReflexContainer,
  ReflexSplitter,
  ReflexElement
} from 'react-reflex';

import Spinner from 'react-spinkit';

import Sidebar from './sidebar';

import SetSaveLocation from './set-save-location';
import TextArea from './textarea';
import TutorialPage from './tutorial-page';
import Footer from './footer';

import Pages from '../enums/pages';

class Layout
  extends Component {

  constructor () {

    super()

    this.toggleSidebar =
      this.toggleSidebar.bind(this)
    this.resizeSidebar =
      this.resizeSidebar.bind(this)

    this.onMinimizeClicked =
      this.onMinimizeClicked.bind(this);

    this.onMaximizeClicked =
      this.onMaximizeClicked.bind(this);
  }

  toggleSidebar() {
    if (this.props.layout.sidebar.real_size > 32) {
      this.onMinimizeClicked();
    }
    else {
      this.onMaximizeClicked();
    }
  }

  resizeSidebar() {
    // useless function
  }

  update(size) {

      return new Promise((resolve) => {
          actions.layout.changeSidebarSize(size);
          resolve();
      })
  }

  animate (from, to, step, done, fn) {

    const stepFn = () => {

      if (!done(from, to)) {

        fn(from += step).then(() => {

          setTimeout(stepFn, 8)
        })
      }
    }

    stepFn ()
  }

  onMinimizeClicked () {

    const currentSize = this.props.layout.sidebar.real_size;
    actions.layout.setSidebarSavedSize(currentSize);

    const done = (from, to) => {

      return from < to
    }

    this.animate (
      currentSize, 25, -8,
      done, this.update)
  }

  onMaximizeClicked () {

    const currentSize = this.props.layout.sidebar.real_size;

    const done = (from, to) => {

      return from > to
    }

    this.animate (
      currentSize, this.props.layout.sidebar.prev_size, 8,
      done, this.update)
  }

  renderCenterPane() {
    if (this.props.layout.loading) {
      return (
        
        <Spinner name="line-scale" />
      )
    }
    switch (this.props.layout.currentPage) {
      case Pages.TEXTAREA:
        return <TextArea />;
      case Pages.SAVE_FILE:
        return <SetSaveLocation />;
      case Pages.TUTORIAL:
        return <TutorialPage />;
      default:
        return null;
    }
  }

  render () {

    return (
      <ReflexContainer orientation="horizontal">
        <ReflexElement size={32}>
          <div className="pane-content">
            
          </div>
        </ReflexElement>
        <ReflexElement>
          
        <ReflexContainer orientation="vertical">

          <Sidebar {...this.props.layout.sidebar}/>

          <ReflexSplitter className='layout-resizer'
            onResize={this.resizeSidebar}>
            {/*<button className='layout-resizer-button'
              onClick={this.toggleSidebar}>
            </button>*/}
          </ReflexSplitter>
              <ReflexElement>
              <Scrollbars>
              <div className='layout-editor'>
                {this.renderCenterPane()}
                </div>
              </Scrollbars>
              </ReflexElement>

        </ReflexContainer>
        </ReflexElement>
        <ReflexElement className='layout-footer' size={32}>
           <Footer />
        </ReflexElement>
      </ReflexContainer>
    )
  }
}

export default connect(state => {
  return {layout: state.layout}
})(Layout)


// WEBPACK FOOTER //
// ./src/components/layout.js